module.exports = __webpack_public_path__ + "img/dver_filenchataya.6ae55601.svg";